<template lang="pug">
  .easyparcel
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .contain-layout(v-else)
      .main-layout(v-if="!action")
        v-container(style="max-width:600px")
          v-layout.my-4
            v-row.fill-height.ma-0(align='center' justify='center' @click="action = null" style="cursor: pointer;")
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/logo_zeptoexpress.png')" style="width:120px" contain)

          v-btn.mt-10.button-AA-medium.white--text.info500(block outlined @click="action = 'setup-account'") {{ $t('setup_account') }}
            v-icon(v-if="settings.setup" right color="green lighten-1") mdi-check-circle

          v-layout.my-6(v-if="isFetchingTransactions")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .transactions-layout.mt-6(v-else)
            div.s1.basic800--text.text-center {{ $t('job_list') }}
            v-layout.my-6(v-if="transactions.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('no_transactions_found') }}
            .transactions(v-else)
              template(v-for="(transaction, index) in transactions")
                v-card(:key="transaction.id" flat)
                  zepto-transaction.white.pa-2(:transaction.sync="transaction")
                v-divider

              div.mx-3.mt-4
                y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

      .action-layout(v-else)
        setup-zepto-express(v-if="action == 'setup-account'" :company="company")

        v-layout.my-8
          v-btn.mx-auto(text @click="action = null")
            v-icon(left small) mdi-arrow-left
            |  {{ $t('main_page') }}
</template>

<script>
import queryString from 'query-string'
import SetupZeptoExpress from '@/views/admin/settings/SetupZeptoExpress.vue'
import ZeptoTransaction from '@/components/ZeptoTransaction.vue'

export default {
  name: 'ZeptoExpress',
  components: { SetupZeptoExpress, ZeptoTransaction },
  props: ['company'],
  data: () => ({
    isFetching: true,
    isFetchingTransactions: true,
    page: 1,
    pageSize: 10,
    count: 0,
    transactions: [],
    settings: {
      setup: false,
      activated: false
    },
    action: null
  }),
  mounted () {
    this.fetchSettings()
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchTransactions(val)
      }
    }
  },
  methods: {
    gotoActivate () {
      this.$router.push('/admin/settings/shipping')
    },
    fetchSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zepto`)
      .then(() => {
          this.settings.setup = true
          this.fetchTransactions(1)
      })
      .catch(()=>{
        this.isFetchingTransactions = false
      })
      .finally(()=>{
        this.isFetching = false
      })

      this.$axios.get(`/invoice_settings/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const invoiceSettings = response.data.results[0]
          if (invoiceSettings.extra_settings) {
            const shippingMethod = invoiceSettings.extra_settings.shipping_method
            if (shippingMethod === 'zepto') {
              this.settings.activated = true
            }
          }
        }
      }).catch(() => {})
    },
    fetchTransactions(page) {
      this.page = parseInt(page)
      this.isFetchingTransactions = true
      let url = `/shipping/shippings?company=${this.company.id}&shipping_method=zepto&page=${page}&page_size=${this.pageSize}&ordering=-id`
      this.$axios.get(url).then((response) => {
        this.isFetchingTransactions = false
        this.transactions = response.data.results
        this.count = response.data.count
      }).catch(() => {})
    }
  }
}
</script>

<i18n>
{
  "en": {
    "setup_account": "setup account",
    "job_list": "Job list",
    "no_transactions_found": "No transactions found",
    "main_page": "main page"
  },
  "id": {
  }
}
</i18n>
